import { BiDatasetGrantInput } from '@euler/model/bi/library';

/** Same grantees with the same permissions, in any order. */
export function biSameDatasetGrants(
  a: BiDatasetGrantInput[],
  b: BiDatasetGrantInput[],
): boolean {
  if (a.length !== b.length) return false;
  const permissions = new Map(
    a.map(grant => [grant.memberId, grant.permission]),
  );
  return b.every(grant => permissions.get(grant.memberId) === grant.permission);
}
